import React from "react";
import { Link } from "react-router-dom";
import Pill from "../ui/Pill";
import { sprintStatusLabel, sprintStatusPill } from "../../domain/sprints";
import { formatShortDate } from "../../lib/formatDate";
import { paths } from "../../routes/paths";

const EMPTY_CELL = "—";

function SprintRow({ sprint, projectId, projectName, selected, onToggle }) {
  const statusLabel = sprintStatusLabel(sprint.status);
  const dueDate = formatShortDate(sprint.due_date);

  // O nome da sprint navega e a caixa marca; o resto da linha alterna a
  // seleção, que é a ação principal da tela.
  const toggleFromRow = (event) => {
    if (event.target.closest("a, .checkcell")) return;
    onToggle(sprint.id);
  };

  return (
    <tr className={selected ? "is-selected" : undefined} onClick={toggleFromRow}>
      <td className="col-check">
        <span className="checkcell">
          <input
            type="checkbox"
            checked={selected}
            onChange={() => onToggle(sprint.id)}
            aria-label={`Selecionar ${sprint.name}`}
          />
        </span>
      </td>

      <td>
        <div className="row-title">
          <Link
            className="row-link"
            to={paths.inconsistencies(projectId, [sprint.id])}
            state={{ projectName, sprintNames: { [sprint.id]: sprint.name } }}
          >
            {sprint.name}
          </Link>
        </div>
        {sprint.description && <div className="row-meta">{sprint.description}</div>}
      </td>

      <td className="col-status">
        {statusLabel ? (
          <Pill variant={sprintStatusPill(sprint.status)}>{statusLabel}</Pill>
        ) : (
          <span className="cell-txt cell-empty">{EMPTY_CELL}</span>
        )}
      </td>

      <td className={dueDate ? "cell-txt col-due" : "cell-txt cell-empty col-due"}>
        {dueDate || EMPTY_CELL}
      </td>
    </tr>
  );
}

export default SprintRow;
